﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import type { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";
import type { SoPNLConsilioTheme } from "../SoPNLConsilioTheme";
import { IRadLogoStyles } from "~jrad/Components/Composite/Logo/IRadLogoStyles";

// ----------------------------------------------------------------------------------------------------
// Theme
// ----------------------------------------------------------------------------------------------------

export default (SoPNLTheme: ConsilioBaseTheme): SoPNLConsilioTheme =>
    Object.assign({}, SoPNLTheme, {
        components: {
            ...SoPNLTheme.components,
            composite: {
                ...SoPNLTheme.components.composite,
                logo: IRadLogoStyles,
            },
        },
    } as IRadConsilioTheme) as IRadConsilioTheme;

// ----------------------------------------------------------------------------------------------------
// Model
// ----------------------------------------------------------------------------------------------------

export interface IRadConsilioTheme extends SoPNLConsilioTheme {}
